import { render, staticRenderFns } from "./transactionRecord.vue?vue&type=template&id=12d66c34&scoped=true"
import script from "./transactionRecord.vue?vue&type=script&lang=js"
export * from "./transactionRecord.vue?vue&type=script&lang=js"
import style0 from "./transactionRecord.vue?vue&type=style&index=0&id=12d66c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d66c34",
  null
  
)

export default component.exports